import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_THUCHINGOAILE } from "actions/ThuChiNgoaiLe/actionTypes";
import {
  getListThuChiNgoaiLeSuccess,
  getListThuChiNgoaiLeFailure,
} from "actions/ThuChiNgoaiLe";
import ThuChiNgoaiLeApi from "service/thuChiNgoaiLeApi";
import { pushNotification } from "utils/notifications";

function* getListThuChiNgoaiLe(action) {
  try {
    const response = yield call(ThuChiNgoaiLeApi.list, action.dataSearch);
    if (response.ok) {
      yield put(getListThuChiNgoaiLeSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getListThuChiNgoaiLeFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getListThuChiNgoaiLeFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_THUCHINGOAILE, getListThuChiNgoaiLe);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
